module.exports = __webpack_public_path__ + "img/1507860735.cb156ccf.jpg";